import React, { useMemo } from 'react';

import CommentSection from '../../CommentSection/CommentSection';

import './CommentItemGroupNewTableContent.scss';

export default function CommentItemGroupNewTableContent({ itemGroupSnapshotState }) {
  const itemGroupVersionQuestions = itemGroupSnapshotState.itemGroupTemplateVersion?.itemGroupVersionQuestions,
    answers = itemGroupSnapshotState.general.rowSnapshotFormData?.form?.answers;

  const commentAnswerField = useMemo(
    function() {
      const commentQuestionFiled = itemGroupVersionQuestions?.find(question => {
        return question.name === 'Comment' && question.label === 'Comment';
      });
      return answers?.find(answer => answer?.itemGroupQuestionId === commentQuestionFiled?.questionId);
    },
    [itemGroupVersionQuestions, answers]
  );

  return (
    <div className="new-table-comment">
      <CommentSection
        snapshotData={{
          commentAnswer: commentAnswerField
        }}
      />
    </div>
  );
}
